import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ComplianceBadge } from "@/components/common";
import { Separator } from "@/components/ui/separator";
import { CheckCircle2, XCircle, ShieldCheck, Droplets } from "lucide-react";

export const ComplianceReport = ({ open, onOpenChange, symbol }) => {
  const [rep, setRep] = useState(null);
  useEffect(() => {
    if (!open || !symbol) return;
    setRep(null);
    api.get(`/halal/report/${symbol}`).then((r) => setRep(r.data)).catch(() => {});
  }, [open, symbol]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg" data-testid="compliance-report">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ShieldCheck className="h-5 w-5" /> Shariah Compliance Report
          </DialogTitle>
        </DialogHeader>
        {!rep ? <div className="py-8 text-center text-muted-foreground">Loading report...</div> : (
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div><div className="font-semibold text-lg">{rep.symbol}</div><div className="text-xs text-muted-foreground">{rep.name}</div></div>
              <ComplianceBadge status={rep.status} testid="report-status" />
            </div>

            <div className="rounded-lg bg-secondary/60 p-3 space-y-2">
              <div className="text-xs font-medium uppercase tracking-wide text-muted-foreground">Screening checks</div>
              {rep.checks.map((c, i) => (
                <div key={c.label ?? i} className="flex items-center justify-between text-sm">
                  <div className="flex items-center gap-2">
                    {c.pass ? <CheckCircle2 className="h-4 w-4 text-emerald-600" /> : <XCircle className="h-4 w-4 text-red-600" />}
                    <span>{c.label}</span>
                  </div>
                  <span className="numeric text-muted-foreground">{c.value}</span>
                </div>
              ))}
            </div>

            <div>
              <div className="text-xs font-medium uppercase tracking-wide text-muted-foreground mb-1.5">Why this rating</div>
              <ul className="space-y-1.5">
                {rep.reasons.map((r, i) => (
                  <li key={`${i}-${r}`} className="text-sm text-foreground flex gap-2"><span className="text-[color:var(--tharwy-lime-700)]">•</span>{r}</li>
                ))}
              </ul>
            </div>

            {rep.status !== "Non-Compliant" && (
              <div className="flex items-center justify-between rounded-lg border p-3">
                <div className="flex items-center gap-2 text-sm"><Droplets className="h-4 w-4 text-[color:var(--tharwy-indigo)]" />Purification required</div>
                <span className="numeric font-medium">{rep.purification_pct}% of dividends</span>
              </div>
            )}

            <Separator />
            <div className="text-xs text-muted-foreground">Methodology: {rep.methodology} · Screened by {rep.screened_by} · Last reviewed {rep.last_reviewed}</div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
